import { eventBus, genString } from "../../plugins/global-funcs"

let list = {}

const state = {
    lang: 'en',
    isLoading: false,
    noti: [
        {
            text: '',
            type: 'error'
        }
    ]
}

const getters = {

}

const actions = {

}

const mutations = {
    setLang (state, val) {
        state.lang = val
    },

    setNotifier (state, val) {
        eventBus.$on('clearNotiTimeout', notiId => {
            window.clearTimeout(list[notiId])
            state.noti = state.noti.filter(x => x.id !== notiId)
        })

        if (state.noti.length > 0 && (state.noti[state.noti.length - 1].text === val.text)) return;

        let id = genString(5)
        state.noti.push({
            text: val.text,
            type: val.type,
            id
        })

        while (state.noti.length > 5) {
            window.clearTimeout(list[state.noti[0].id])
            state.noti.shift()
        }

        list[id] = setTimeout(() => {
            state.noti = state.noti.filter(x => x.id !== id)
        }, 5000)
    },

    clearAllNoti (state) {
        state.noti = []
    },

    setLoading (state, val = true) {
        state.isLoading = val
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
